
















import Vue from 'vue';

interface Tab {
  name: string;
  title: string;
}

export default Vue.extend({
  name: 'StudioCommunityGroupTabs',
  props: {
    group: {},
  },
  computed: {
    tabs(): Tab[] {
      return [
        {
          name: 'feed',
          title: this.$t('COMMUNITY.LINK.FEED'),
          routeName: 'studio-community-feed',
          show: true,
        },
        {
          name: 'members',
          title: this.$t('COMMUNITY.LINK.MEMBERS'),
          routeName: 'studio-community-members',
          show: this.group?.display_members,
        },
        {
          name: 'about',
          title: this.$t('COMMUNITY.LINK.ABOUT'),
          routeName: 'studio-community-group-description',
          show: true,
        },
      ].filter(t => t.show);
    },
    selectedTab: {
      get() {
        const selectedTab = this.tabs.find(
          ({ routeName }) => this.$route.name === routeName
        );
        return selectedTab?.name;
      },
      set(tabName) {
        const routeName = this.tabs.find(({ name }) => name === tabName);
        if (routeName) this.$router.replace({ name: routeName?.routeName });
      },
    },
  },
  methods: {
    shouldShowAboutTab(tab) {
      return tab.name === 'about' && this.group?.about_text;
    },
  },
});
